<template>
  <simple-page header="设备授权" @query="query">
    <template #buttons>
      <el-button type="primary" @click="save" :loading="loading">
        保存
      </el-button>
    </template>
    <template #west>
      <div class="user-list">
        <el-divider content-position="left">用户列表</el-divider>
        <div v-for="user in users" :class="'user-item '+(queryForm.userId == user.userId ? 'active':'')"
             @click="userChange(user.userId)">
          <span>{{user.userName}}</span>
        </div>
      </div>
    </template>
    <template #form v-if="queryForm.userId">
      <el-form inline>
        <el-form-item label="所属单位">
          <comp-select v-model="queryForm.compId" @change="query" style="width: 180px"></comp-select>
        </el-form-item>
        <el-form-item label="所属区域">
          <area-cascader v-model="areaCodes" @change="areaChange"></area-cascader>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model.trim="queryForm.deviceName" clearable
                    placeholder="请输入设备编码或设备名称"
                    @keyup.enter.native="query"
                    style="width: 180px"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <el-table ref="tab" stripe :data="records" :border="true" v-loading="loading"
              row-key="deviceCode"
              v-if="queryForm.userId"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="deviceCode" label="设备编号" align="center" min-width="130"></el-table-column>
      <el-table-column prop="deviceName" label="设备名称" min-width="130"></el-table-column>
      <el-table-column prop="address" label="地址" min-width="200"></el-table-column>
      <el-table-column prop="deviceTypeName" label="设备类型" align="center" width="100"></el-table-column>
      <column-valid prop="valid" label="启用" width="60"></column-valid>
      <column-valid prop="online" label="在线" width="60"></column-valid>
    </el-table>
    <table-pagination :page-query="queryForm" :total="total" @change="loadData" v-if="queryForm.userId"></table-pagination>
    <el-empty v-if="!queryForm.userId">请选择用户</el-empty>
  </simple-page>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import AppUpload from "@/components/app-version/AppUpload";
import SimplePage from "@/components/page/SimplePage.vue";
import TitleSection from "@/components/section/TitleSection.vue";
import CompSelect from "@/components/base/CompSelect.vue";
import ColumnValid from "@/components/tableColumns/ColumnValid.vue";
import AreaCascader from "@/components/base/AreaCascader.vue";
import SessionStore from "@/utils/SessionStore";
export default {
  name: 'MyDeviceList',
  components: {AreaCascader, ColumnValid, CompSelect, TitleSection, SimplePage, AppUpload, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      areaCodes: [],
      user: {
      },
      queryForm: {
        userId: null,
        online: "",
        page: 1,
        limit: 10
      },
      total: 0,
      users: [],
      records: [],
      selectedRecords: [],
      device: null
    }
  },
  created() {
    this.user = SessionStore.getUser();
    if(!this.user.superAdmin && !this.user.roles.find(r=>r.roleCode === "super_admin")) {
      if(this.user.company.provCode) {
        this.areaCodes.push(this.user.company.provCode);
        if(this.user.company.cityCode) {
          this.areaCodes.push(this.user.company.cityCode);
        }
      }
    }
    this.getUsers();
  },
  methods: {
    query(){
      if(!this.queryForm.userId) {
        return;
      }
      this.queryForm.page = 1;
      this.loadData();
    },
    getUsers() {
      this.loading = true;
      this.postForm("/user/myUsers", null, true).then(dr => {
        this.users = dr.rows;
      }).finally(()=>{
        this.loading = false;
      })
    },
    userChange(userId) {
      this.queryForm.userId = userId;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/person-device/getPersonDeviceList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
        this.$nextTick(()=>{
          this.records.forEach(d=>{
            if(d.checked) {
              this.selectedRecords.push(d);
              this.$refs.tab.toggleRowSelection(d);
            }
          });
        })
      }).finally(()=>{
        this.loading = false;
      })
    },
    handleSelectionChange(rows){
      this.selectedRecords = rows;
    },
    save() {
      if(this.records.length == 0){
        this.$message.warning("请选择用户");
        return;
      }
      let data = [];
      this.records.forEach(d => {
        let checked = false;
        for (let i = 0; i < this.selectedRecords.length; i++) {
          if(d.deviceCode == this.selectedRecords[i].deviceCode) {
            checked = true;
            break;
          }
        }
        data.push({
          deviceCode: d.deviceCode,
          checked: checked
        });
      });
      this.loading = true;
      this.postJson("/person-device/save?userId="+this.queryForm.userId,data,true).finally(()=>{
        this.loading = false;
      });
    },
    areaChange(){
      if(this.areaCodes.length > 0) {
        this.queryForm.provCode = this.areaCodes[0];
        this.queryForm.cityCode = this.areaCodes[1];
        this.queryForm.townCode = this.areaCodes[2];
      } else {
        this.queryForm.provCode = null;
        this.queryForm.cityCode = null;
        this.queryForm.townCode = null;
      }
      this.query();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/variables";
.user-list{
  width: 160px;
  .user-item{
    cursor: pointer;
    padding: 5px;
    margin-bottom: 10px;
  }
  .user-item.active{
    color: $color-primary;
  }
}

</style>